/**
 * The same public redirect records used by the backend, including aliases
 * added after the React website was retired.
 */
import redirects from '../../shared/public/redirects.json';
import { publicPageAlias } from '../../shared/public/page-routes.cjs';

function normalizePath(pathname) {
  const raw = String(pathname || '').split('?')[0].split('#')[0] || '/';
  if (raw === '/') return '/';
  return raw.replace(/\/+$/, '') || '/';
}

const REDIRECT_LOOKUP = new Map(
  Object.entries(redirects).map(([from, to]) => [normalizePath(from).toLowerCase(), to]),
);

/** Returns redirect target for `pathname`, or null if none. Case-insensitive. */
export function getPublicRedirectTarget(pathname) {
  return publicPageAlias(normalizePath(pathname)) || REDIRECT_LOOKUP.get(normalizePath(pathname).toLowerCase()) || null;
}
